import React from "react";
import styled, { keyframes } from "styled-components";

const Placeholder = () => {
  return (
    <PlaceholderContainer>
      <Shimmer />
      <PlaceholderRow />
      <PlaceholderRow />
      <PlaceholderRow />
      <PlaceholderRow />
    </PlaceholderContainer>
  );
};

export default Placeholder;

const shimmerAnimation = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

const PlaceholderContainer = styled.div`
  width: 90%;
  padding: 20px;
  border-radius: 5px;
  background-color: #f3f3f3;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

const Shimmer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 400% 100%;
  animation: ${shimmerAnimation} 1.5s infinite;
`;

const PlaceholderRow = styled.div`
  width: 80%;
  height: 15px;
  margin: 10px 0;
  background: #ddd;
  border-radius: 4px;
`;